import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';
import store from '@/store';
import {authCheck} from '@/utils';
Vue.use(Router);

import Layout from '@/views/layout/Layout';

//基本信息管理
const App = () => import('@/views/basic/App/AppInfo');
const Device = () => import('@/views/basic/Device/Device');
const Event = () => import('@/views/basic/Event/EventDictionary');
const Package = () => import('@/views/basic/Package/Package');

// 应用统计分析
const AppCrashLog = () => import('@/views/statistics/AppCrashLog/AppCrashLog');
const DownLoadLog = () => import('@/views/statistics/DownLoadLog/DownLoadLog');
const EventLog = () => import('@/views/statistics/EventLog/EventLog');
const Log = () => import('@/views/statistics/Log/Log');
const AppDeviceInfo = () => import('@/views/statistics/AppDeviceInfo/AppDeviceInfo');
const UserActivityStatistics = () => import('@/views/statistics/UserActivityStatistics/UserActivityStatistics');
const UserDownloadStatistics = () => import('@/views/statistics/UserDownloadStatistics/UserDownloadStatistics');
const UserActivitySectionStatistics = () => import('@/views/statistics/UserActivitySectionStatistics/UserActivitySectionStatistics');

//系统设置
const ConfigInfo = () =>
  import('@/views/systemSettings/ConfigInfo/ConfigInfo');
const DataDictionaryInfo = () =>
  import('@/views/systemSettings/DataDictionaryInfo/DataDictionaryInfo');
const AppVersionSecretkey = () =>
  import('@/views/systemSettings/AppVersionSecretkey/AppVersionSecretkey');

//版本更新
const version = () => import('@/views/layout/components/version');

const constantRouterMap = [
  { path: '/', component: () => import('@/views/Download/DownloadAppList'), hidden: true },
    {
        path: '/login',
        component: () => import('@/views/login/index'),
        hidden: true
    },
    {path: '/404', component: () => import('@/views/errorPage/404'), hidden: true},
    {path: '/401', component: () => import('@/views/errorPage/401'), hidden: true},
    {
        path: '/admin',
        component: Layout,
        redirect: 'dashboard',
        children: [{
            path: 'dashboard',
            //component: () => import('@/views/dashboard/index'),
            component: () => import('@/views/home/MainHomeIndex'),
            name: 'dashboard',
            meta: {title: 'dashboard', icon: 'dashboard', noClose: true}
        }]
    },
    {path: '/Download', component: () => import('@/views/Download/DownloadAppList'), hidden: true},
    {path: '/DownloadApp', component: () => import('@/views/Download/DownloadApp'), hidden: true},
    {path: '/Advice', component: () => import('@/views/advice/Advice'), hidden: true}
];

const asyncRouterMap = [
  { path: '/', component: () => import('@/views/Download/DownloadAppList'), hidden: true },
    {
        path: '/login',
        component: () => import('@/views/login/index'),
        hidden: true
    },
    {path: '/404', component: () => import('@/views/errorPage/404'), hidden: true},
    {path: '/401', component: () => import('@/views/errorPage/401'), hidden: true},
    {
      path: '/admin',
        component: Layout,
      redirect: '/admin/dashboard',
        children: [{
          path: '/admin/dashboard',
            component: () => import('@/views/home/MainHomeIndex'),
          name: 'dashboard',
          meta: {title: 'dashboard', icon: 'dashboard', noClose: true}
        },
        {
          path: '/components/version',
          name: 'version',
          component: version,
          meta: {
            title: 'version'
          }
        }]
    },

    {path: '/Download', component: () => import('@/views/Download/DownloadAppList'), hidden: true},
    {path: '/DownloadApp', component: () => import('@/views/Download/DownloadApp'), hidden: true},
    {path: '/Advice', component: () => import('@/views/advice/Advice'), hidden: true},

    {
        path: '/Basic',
        component: Layout,
        alwaysShow: true,
        meta: {
            title: 'Basic',
        },
        children: [
            {
                path: '/Basic/App',
                name: 'App',
                component: App,
                meta: {
                    title: 'App',
                },
            },
            {
                path: '/Basic/Device',
                name: 'Device',
                component: Device,
                meta: {
                    title: 'Device',
                },
            },
            {
                path: '/Basic/Event',
                name: 'Event',
                component: Event,
                meta: {
                    title: 'Event',
                },
            },
            {
                path: '/Basic/Package',
                name: 'Package',
                component: Package,
                meta: {
                    title: 'Package',
                },
            }
        ]
    },
    {
        path: '/Statistics',
        component: Layout,
        alwaysShow: true,
        meta: {
            title: 'Statistics',
        },
        children: [
            {
                path: '/Statistics/AppCrashLog',
                name: 'AppCrashLog',
                component: AppCrashLog,
                meta: {
                    title: 'AppCrashLog',
                },
            },
            {
                path: '/Statistics/DownLoadLog',
                name: 'DownLoadLog',
                component: DownLoadLog,
                meta: {
                    title: 'DownLoadLog',
                },
            },
            {
                path: '/Statistics/EventLog',
                name: 'EventLog',
                component: EventLog,
                meta: {
                    title: 'EventLog',
                },
            },
            {
                path: '/Statistics/Log',
                name: 'Log',
                component: Log,
                meta: {
                    title: 'Log',
                },
            },
            {
                path: '/Statistics/AppDeviceInfo',
                name: 'AppDeviceInfo',
                component: AppDeviceInfo,
                meta: {
                    title: 'AppDeviceInfo',
                },
            },
            {
                path: '/Statistics/UserActivityStatistics',
                name: 'UserActivityStatistics',
                component: UserActivityStatistics,
                meta: {
                    title: 'UserActivityStatistics',
                },
            },
            {
                path: '/Statistics/UserDownloadStatistics',
                name: 'UserDownloadStatistics',
                component: UserDownloadStatistics,
                meta: {
                    title: 'UserDownloadStatistics',
                },
            },
            {
                path: '/Statistics/UserActivitySectionStatistics',
                name: 'UserActivitySectionStatistics',
                component: UserActivitySectionStatistics,
                meta: {
                    title: 'UserActivitySectionStatistics',
                },
            }
        ]
    },
    {
        path: '/System',
        component: Layout,
        alwaysShow: true,
        meta: {
            title: 'System',
        },
        children: [
            {
                path: '/SystemSetting/ConfigInfo',
                name: 'ConfigInfo',
                component: ConfigInfo,
                meta: {
                  title: 'ConfigInfo',
                },
            },
            {
                path: '/SystemSetting/DataDictionaryInfo',
                name: 'DataDictionaryInfo',
                component: DataDictionaryInfo,
                meta: {
                  title: 'DataDictionaryInfo',
                },
            },
            {
                path: '/SystemSetting/AppVersionSecretkey',
                name: 'AppVersionSecretkey',
                component: AppVersionSecretkey,
                meta: {
                  title: 'AppVersionSecretkey',
                },
            },
        ]
  },
  {
    path: '*',
    component: () => import('@/views/Download/DownloadAppList')
  }
];

export {
    asyncRouterMap,
    constantRouterMap
};

const createRouter = () => new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({y: 0}),
    routes: asyncRouterMap
});

const router = createRouter();
// const router = new Router({
//     mode: 'history',
//     routes: [
//         {
//             path: '/',
//             component: Layout,
//             redirect: '/dev/curd',
//             children: [
//                 {
//                     path: 'systemSettings/DataDictionaryInfo',
//                     name: 'DataDictionaryInfo',
//                     component: DataDictionaryInfo,
//                     meta: {
//                         tabTitle: t => t('main.nav-menu.system-settings.data-dictionary-info')
//                     }
//                 },
//             ]
//         }
//     ]
// });

NProgress.configure({showSpinner: true});

const whiteList = ['/login', '/auth-redirect', '/401', '/404', '/Download', '/DownloadApp', '/download', '/downloadApp','/'];
router.beforeEach(async (to, from, next) => {
    NProgress.start();
    const token = store.getters.token;
    if (whiteList.includes(to.path)) {
        next();
        return;
    }

    if (!token) {
        try {
          const userInfo = await store.dispatch('getUserInfo');        
            next('/admin');
            return;
        } catch (error) {
            console.log(error);
        }
        next(`/login?redirect=${to.path}`);
        return;
    }
    const {permissions} = store.getters;
    if (!permissions) {
        const userInfo = await store.dispatch('getUserInfo');
        await store.dispatch('getPermissions', userInfo.id);
    }
    //check
    if (authCheck(to.meta.permissions)) {
        next();
    } else {
        next('/404');
    }
    //if (permissions) {
    //    next();
    //    return;
    //}
    //try {
    //    const userInfo = await store.dispatch('getUserInfo');
    //    await store.dispatch('getPermissions', userInfo.id);
    //    const accessRoutes = await store.dispatch('generateRoutes');
    //    router.addRoutes(accessRoutes);
    //    next({...to, replace: true});
    //} catch (error) {
    //    console.log(error);
    //    next(`/login?=${to.path}`);
    //}
});

router.afterEach(() => {
    NProgress.done();
});


export default router;
